export default __webpack_public_path__ + "static/cp-app-mobile-85e7511c290d239760a7db8f5cc665b6.jpg";